import api from '../api';

/**
 * Submit a form response (public - no auth required)
 */
export const submitResponse = async (formId, responseData) => {
  try {
    const response = await api.post(`/responses/${formId}`, responseData);
    return response;
  } catch (error) {
    console.error('Error submitting response:', error);
    throw error;
  }
};

/**
 * Get all responses for a form
 */
export const getFormResponses = async (formId) => {
  try {
    const response = await api.get(`/responses/${formId}/list`);
    return response;
  } catch (error) {
    console.error('Error fetching responses:', error);
    throw error;
  }
};

/**
 * Get analytics for a form
 */
export const getFormAnalytics = async (formId) => {
  try {
    const response = await api.get(`/responses/${formId}/analytics`);
    return response;
  } catch (error) {
    console.error('Error fetching analytics:', error);
    throw error;
  }
};

/**
 * Get response counts for all user's forms
 */
export const getResponseCounts = async () => {
  try {
    const response = await api.get(`/responses/counts/all`);
    return response;
  } catch (error) {
    console.error('Error fetching response counts:', error);
    throw error;
  }
};

/**
 * Get dashboard statistics
 */
export const getDashboardStats = async () => {
  try {
    const response = await api.get(`/responses/dashboard/stats`);
    return response;
  } catch (error) {
    console.error('Error fetching dashboard stats:', error);
    throw error;
  }
};
